import DeqFactory from 'digitaleventqueue/src/DEQFactory.js';

import { Injectable, inject } from '@angular/core';

import { ApWindowService } from '@ap/cdk';

import { FormFieldValue } from '../analytics.model';

@Injectable({
    providedIn: 'root'
})
export class ApDatalayerService {
    public DEQFactory: any; // eslint-disable-line
    public DEQInstance: any; // eslint-disable-line

    public constructor() {
        const windowService = inject(ApWindowService);

        const window = windowService.getWindow() as any;
        this.DEQFactory = window.DEQFactory ? window.DEQFactory : DeqFactory;
        window.DEQFactory = this.DEQFactory;
        window.digitalData = this.DEQFactory.get('digitalData', window.digitalData);
        window.processedData = this.DEQFactory.get('processedData', window.processedData);
        this.DEQInstance = window.digitalData;
    }

    public anonymizeData(values: FormFieldValue[]): any[] {
        return values.map((item: any) => {
            if (typeof item.anonymizeAs === 'function') {
                item.value = item.anonymizeAs(item.value);
            }
            delete item.anonymizeAs;
            return item;
        });
    }

    public pushData(eventName: string, eventData: any = {}): void {
        if (eventName === 'form step' && eventData.formFieldValues) {
            eventData.formFieldValues = this.anonymizeData(eventData.formFieldValues);
        }

        Object.keys(eventData).forEach((key) => eventData[key] === undefined && delete eventData[key]);

        this.DEQInstance.push({
            command: 'ADD EVENT',
            name: eventName,
            data: eventData
        });
    }
}
